import React, { useState } from "react";
import {
  Box, Button, Container, FormControl, FormLabel, Heading, HStack,
  Input, Link, Text, Textarea, VStack
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const brand = { green: "#1C4C3F", cream: "#F7F5EB", ink: "#0E2721" };

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleMailto = (e) => {
    e.preventDefault();
    const subject = `ShelfKey contact from ${name || "Website"}`;
    const body = `Name: ${name}\nEmail: ${email}\n\n${message}`;
    window.location.href =
      `mailto:hello@shelfkey.co?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const canSend = email.trim().length > 3 && message.trim().length > 2;

  return (
    <Box bg={brand.cream} color={brand.ink} minH="100vh">
      <Container maxW="3xl" px={{ base: 4, md: 6 }} py={{ base: 14, md: 20 }}>
        <VStack align="start" spacing={6}>
          <Heading size="2xl">Talk to us</Heading>
          <Text fontSize="lg" opacity={0.9}>
            Questions, feedback, or want a quick demo? Email{" "}
            <Link href="mailto:hello@shelfkey.co" color={brand.green}>
              hello@shelfkey.co
            </Link>{" "}
            and we’ll get back within a business day.
          </Text>

          <Box bg="white" border="1px solid #EAEAEA" borderRadius="lg" p={6} w="100%">
            <VStack align="stretch" spacing={4} as="form" onSubmit={handleMailto}>
              <FormControl>
                <FormLabel>Your name</FormLabel>
                <Input
                  placeholder="Jane Doe"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Your email</FormLabel>
                <Input
                  type="email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Message</FormLabel>
                <Textarea
                  rows={5}
                  placeholder="How can we help?"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </FormControl>

              <Button
                type="submit"
                onClick={handleMailto}
                bg={brand.green}
                color="white"
                isDisabled={!canSend}
              >
                Open email to send
              </Button>

              <Text fontSize="sm" opacity={0.8}>
                Prefer hands-on consulting with a human touch? Visit{" "}
                <Link href="https://liftcpg.com" isExternal color={brand.green} fontWeight="semibold">
                  LiftCPG.com
                </Link>{" "}
                for services and engagement options.
              </Text>

              <HStack>
                <Button as={RouterLink} to="/" variant="outline">Back to home</Button>
                <Button as={RouterLink} to="/signup" bg={brand.green} color="white">Start free</Button>
              </HStack>
            </VStack>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
}
